import {createAction, handleActions} from 'redux-actions';
import {Api} from "../../api/api";
import {logout, onForbidden} from '../account/login';
import _ from 'lodash';
import {LOCATION_MAP} from '../../constants/constants';

export const COMPANIES_CREDITS_SORTING = {
    NAME: "NAME",
    CREATED_AT: "CREATED_AT"
};

//- Actions
export const fetchGetCompaniesCreditsFailed = createAction('FETCH_GET_COMPANIES_CREDITS_FAILED');
export const fetchGetCompaniesCreditsSuccess = createAction('FETCH_GET_COMPANIES_CREDITS_SUCCESS');
export const onGetCompaniesCreditsSuccess = (data) => (dispatch) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    if ((!isEmpty && currentPage !== 0) || currentPage === 0) {
        dispatch(fetchGetCompaniesCreditsSuccess(data));
    } else {
        dispatch(fetchGetCompaniesCredits(currentPage - 1));
    }
};
export const onFetchGetCompaniesCredits = createAction(
    'FETCH_GET_COMPANIES_CREDITS',
    (page, sorting, name, countries) => Api.getCompaniesCredits(page, sorting, name, countries),
    () => ({
        apiCall: true,
        onSuccess: onGetCompaniesCreditsSuccess,
        onFail: fetchGetCompaniesCreditsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchGetCompaniesCredits = (page) => (dispatch, getState) => {
    let sorting = getCompaniesCreditsSorting(getState());
    let name = getCompaniesCreditsNameFilter(getState());
    let countries = getCompaniesCreditsCountryFilter(getState());
    dispatch(onFetchGetCompaniesCredits(page, sorting, name, countries));
};

export const onUpdateCompaniesCreditsSorting = createAction('UPDATE_COMPANIES_CREDITS_SORTING');
export const updateCompaniesCreditsSorting = (sorting) => (dispatch, getState) => {
    let name = getCompaniesCreditsNameFilter(getState());
    let countries = getCompaniesCreditsCountryFilter(getState());
    dispatch(onFetchGetCompaniesCredits(0, sorting, name, countries));
    dispatch(onUpdateCompaniesCreditsSorting(sorting));
};

export const onUpdateCompaniesCreditsNameFilter = createAction('UPDATE_COMPANIES_CREDITS_NAME_FILTER');
export const updateCompaniesCreditsNameFilter = (name) => (dispatch, getState) => {
    let sorting = getCompaniesCreditsSorting(getState());
    let countries = getCompaniesCreditsCountryFilter(getState());
    dispatch(onFetchGetCompaniesCredits(0, sorting, name, countries));
    dispatch(onUpdateCompaniesCreditsNameFilter(name));

}

export const updateCompanyCreditsCountryFilter = createAction('UPDATE_COMPANIES_CREDITS_COUNTRY_FILTER');

export const onUpdateCompanyCreditsCountryFilter = (country) => (dispatch) => {
    let countries = country ? [country] : null;
    dispatch(updateCompanyCreditsCountryFilter(countries));
    dispatch(getCompanyCreditsByCountryFilter(countries));
};

export const onUpdateCompanyCreditsCountryFilterByContinent = (continent) => (dispatch) => {
    let countries = continent ? LOCATION_MAP[continent] : null;
    dispatch(updateCompanyCreditsCountryFilter(countries));
    dispatch(getCompanyCreditsByCountryFilter(countries));
};

export const getCompanyCreditsByCountryFilter = (countries) => (dispatch, getState) => {
    let sorting = getCompaniesCreditsSorting(getState());
    let name = getCompaniesCreditsNameFilter(getState());

    dispatch(onFetchGetCompaniesCredits(0, sorting, name, countries));
};

export const onFetchGetCompanyHistoryFailed = createAction('FETCH_GET_COMPANY_HISTORY_FAILED');
export const onFetchGetCompanyHistorySuccess = createAction('FETCH_GET_COMPANY_HISTORY_SUCCESS');
export const onGetCompanyHistorySuccess = (data) => (dispatch, getState) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    let id = getSelectedCompanyId(getState());
    if ((!isEmpty && currentPage !== 0) || currentPage === 0) {
        dispatch(onFetchGetCompanyHistorySuccess(data));
    } else {
        dispatch(onFetchGetCompanyHistory(currentPage - 1, id));
    }
};
export const onFetchGetCompanyHistory = createAction('FETCH_GET_COMPANY_HISTORY',
    (page, id) => Api.getCompanyCreditsHistory(page, id),
    () => ({
        apiCall: true,
        onSuccess: onGetCompanyHistorySuccess,
        onFail: onFetchGetCompanyHistoryFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const getCompanyHistory = (page) => (dispatch, getState) => {
    let id = getSelectedCompanyId(getState());
    dispatch(onFetchGetCompanyHistory(page, id));
}

export const setSelectedCompanyId = createAction('SELECTED_COMPANY_ID_SET');
export const setSelectedCompanyName = createAction('SELECTED_COMPANY_NAME_SET');

//- State
const initialState = {
    data: null,
    fetching: false,
    error: null,
    currentPage: null,
    totalPages: null,
    sorting: COMPANIES_CREDITS_SORTING.NAME,
    nameFilter: null,
    selectedCompanyName: null,
    selectedCompanyId: null,
    countryFilter: null,
    companyHistory: null,
    companyHistoryFetching: false,
    companyHistoryError: null,
    companyHistoryCurrentPage: null,
    companyHistoryTotalPages: null,
};

//- Reducers
export default handleActions({
    FETCH_GET_COMPANIES_CREDITS: (state) => {
        return {...state, data: null, currentPage: null, totalPages: null, error: null, fetching: true};
    },
    FETCH_GET_COMPANIES_CREDITS_FAILED: (state, action) => {
        return {...state, data: null, currentPage: null, totalPages: null, error: action.payload, fetching: false};
    },
    FETCH_GET_COMPANIES_CREDITS_SUCCESS: (state, action) => {
        return {
            ...state,
            data: action.payload.content,
            currentPage: action.payload.number,
            totalPages: action.payload.totalPages,
            error: null,
            fetching: false
        };
    },
    UPDATE_COMPANIES_CREDITS_SORTING: (state, action) => {
        return {...state, sorting: action.payload};
    },
    UPDATE_COMPANIES_CREDITS_NAME_FILTER: (state, action) => {
        return {...state, nameFilter: action.payload};
    },
    UPDATE_COMPANIES_CREDITS_COUNTRY_FILTER: (state, action) => {
        return {...state, countryFilter: action.payload};
    },
    FETCH_GET_COMPANY_HISTORY: (state) => {
        return {
            ...state,
            companyHistory: null,
            companyHistoryFetching: true,
            companyHistoryError: null,
            companyHistoryCurrentPage: null,
            companyHistoryTotalPages: null
        };
    },
    FETCH_GET_COMPANY_HISTORY_FAILED: (state, action) => {
        return {
            ...state,
            companyHistory: null,
            companyHistoryFetching: false,
            companyHistoryError: action.payload,
            companyHistoryCurrentPage: null,
            companyHistoryTotalPages: null
        };
    },
    FETCH_GET_COMPANY_HISTORY_SUCCESS: (state, action) => {
        return {
            ...state,
            companyHistory: action.payload.content,
            companyHistoryFetching: false,
            companyHistoryError: null,
            companyHistoryCurrentPage: action.payload.number,
            companyHistoryTotalPages: action.payload.totalPages
        };
    },
    SELECTED_COMPANY_ID_SET: (state, action) => {
        return {...state, selectedCompanyId: action.payload};
    },
    SELECTED_COMPANY_NAME_SET: (state, action) => {
        return {...state, selectedCompanyName: action.payload};
    }
}, initialState);

//- Selectors
export const getCompaniesCredits = state => state.companiesCredits;

export const loadingCompaniesCredits = state => getCompaniesCredits(state).fetching;

export const getCurrentPageForCompaniesCredits = state => getCompaniesCredits(state).currentPage;

export const getTotalPagesForCompaniesCredits = state => getCompaniesCredits(state).totalPages;

export const getCompaniesCreditsData = state => {
    let data = getCompaniesCredits(state).data;
    if (_.isNil(data)) {
        return null;
    }

    return _.map(data, elem => {
        let totalCredit = [];

        _.forEach(elem.transactionStatistic, transactions => {
            _.forEach(transactions, transaction => {
                let index = totalCredit.findIndex(el => el.currency === transaction.currency);
                if (index !== -1) {
                    totalCredit[index].amount += transaction.amount;
                } else {
                    totalCredit.push({
                        currency: transaction.currency,
                        amount: transaction.amount
                    });
                }
            });
        });

        return {
            id: elem.target.id,
            name: elem.target.name,
            joinDate: elem.target.createdAt,
            openCredit: elem.target.balance,
            totalCredit: totalCredit,
            contactData: {
                firstName: elem.target.anchor.identityAlias.firstName,
                lastName: elem.target.anchor.identityAlias.lastName,
                email: elem.target.anchor.email,
                phoneNumber: elem.target.anchor.identityAlias.phoneNumber,
            }
        };
    });
};

export const getCompaniesCreditsSorting = state => getCompaniesCredits(state).sorting;

export const getCompaniesCreditsNameFilter = state => getCompaniesCredits(state).nameFilter;

export const getCompaniesCreditsCountryFilter = state => getCompaniesCredits(state).countryFilter;

export const getSelectedCompanyId = state => getCompaniesCredits(state).selectedCompanyId;

export const getCompanyHistoryData = state => {
    let data = getCompaniesCredits(state).companyHistory;
    if (_.isNil(data)) {
        return null;
    }

    return _.map(data, elem => {
        return {
            createdAt: elem.transaction.createdAt,
            delta: elem.transaction.delta,
            comment: elem.transaction.metadata.comment
        }
    })
};

export const loadingCompanyHistory = state => getCompaniesCredits(state).companyHistoryFetching;

export const getCompanyHistoryCurrentPage = state => getCompaniesCredits(state).companyHistoryCurrentPage;

export const getCompanyHistoryTotalPages = state => getCompaniesCredits(state).companyHistoryTotalPages;

export const getSelectedCompanyName = state => getCompaniesCredits(state).selectedCompanyName;


// WEBPACK FOOTER //
// ./src/reducers/systemPayments/companiesCredits.js